var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "proposal-profile" },
    [
      _c("section-title", {
        staticClass: "my-4 proposal-profile__section-title",
        attrs: {
          icon: "fas fa-info-circle",
          reverse: "",
          title: "Información de PO",
          "title-class": "proposal-profile__section-title__info"
        }
      }),
      _c("div", { staticClass: "general-info bg-secondary-3 p-4 rounded" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Número de PO:")]),
            _c("p", { staticClass: "content" }, [
              _vm._v(" " + _vm._s(_vm.details.poNumber || "-") + " ")
            ])
          ]),
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v("Fecha de registro:")
            ]),
            _c("p", { staticClass: "content" }, [
              _vm._v(
                " " +
                  _vm._s(_vm._f("date")(_vm.details.poDate, "dd MMM yyyy")) +
                  " "
              )
            ])
          ]),
          _c("div", { staticClass: "col" }, [
            _c("span", { staticClass: "title" }, [_vm._v("Balance de PO:")]),
            _c("p", { staticClass: "content" }, [
              _vm._v(
                " " + _vm._s(_vm._f("currency")(_vm.details.poBalance)) + " "
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }